const qaOberturaDiaria = [
    {
        name: 'BlocREDL',
        finalProps: {
            name: 'Obertura diaria'
        },
        children: [
            {
                name: 'Fila',
                finalProps: {
                    columnes: '8_4',
                    tipus: 'fixed'
                },

                children: [
                    {
                        name: 'Columna',
                        children: [
                            {
                                name: 'Destacat',
                                finalProps: {
                                    isLoading: true,
                                    tipologia: 'NOT_NOTICIA'
                                }
                            },
                            {
                                name: 'Fila',
                                finalProps: {
                                    columnes: '3_3_3_3',
                                    tipus: 'fixed'
                                },
                                children: [
                                    {
                                        name: 'Destacat',
                                        finalProps: {
                                            isLoading: true,
                                            tipologia: 'NOT_NOTICIA'
                                        }
                                    },
                                    {
                                        name: 'Destacat',
                                        finalProps: {
                                            isLoading: true,
                                            tipologia: 'NOT_NOTICIA'
                                        }
                                    },
                                    {
                                        name: 'Destacat',
                                        finalProps: {
                                            isLoading: true,
                                            tipologia: 'NOT_NOTICIA'
                                        }
                                    },
                                    {
                                        name: 'Destacat',
                                        finalProps: {
                                            isLoading: true,
                                            tipologia: 'NOT_NOTICIA'
                                        }
                                    }
                                ]
                            }
                        ]
                    },
                    {
                        name: 'Columna',
                        children: [
                            {
                                name: 'Destacat',
                                finalProps: {
                                    isLoading: true,
                                    tipologia: 'NOT_NOTICIA'
                                }
                            },
                            {
                                name: 'Destacat',
                                finalProps: {
                                    isLoading: true,
                                    tipologia: 'NOT_NOTICIA'
                                }
                            }
                        ]
                    }
                ]
            }
        ]
    }
];

export default qaOberturaDiaria;
